module.exports = __webpack_public_path__ + "static/weJay4-bd4a4c37894699069bb29b0c55798586.png";